function _typeof(o) {
  '@babel/helpers - typeof';
  return (
    (_typeof =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (o) {
            return typeof o;
          }
        : function (o) {
            return o &&
              'function' == typeof Symbol &&
              o.constructor === Symbol &&
              o !== Symbol.prototype
              ? 'symbol'
              : typeof o;
          }),
    _typeof(o)
  );
}
var _excluded = [
  'prefixCls',
  'className',
  'treeData',
  'treeNodeActionMenu',
  'icon',
  'switcherIconPosition',
  'indentUnitWidth',
  'titleRender',
  'treeNodeActionMenuTrigger',
  'highlightKeyword',
  'loading',
  'getPopupContainer',
];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r &&
      (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })),
      t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2
      ? ownKeys(Object(t), !0).forEach(function (r) {
          _defineProperty(e, r, t[r]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
      : ownKeys(Object(t)).forEach(function (r) {
          Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, 'string');
  return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}
function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t =
    null == r ? null : ('undefined' != typeof Symbol && r[Symbol.iterator]) || r['@@iterator'];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (((i = (t = t.call(r)).next), 0 === l)) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {}
    } catch (r) {
      (o = !0), (n = r);
    } finally {
      try {
        if (!f && null != t.return && ((u = t.return()), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React, { useCallback, useEffect, useState } from 'react';
import { Empty, Spin, Tree } from 'udesk-ui';
import classNames from 'classnames';
import { TreeNode } from './components/TreeNode';
import { usePrefixCls } from '../utils';
import { TreeMenuWrap } from './components/TreeMenuWrap';
import { filterTreeDataByKeyword, formatTreeDataFromArrayToTree } from './utils';
import './style/index';
var DirectoryTree = Tree.DirectoryTree;
var defaultIconRender = function defaultIconRender(props) {
  return null;
};
var TreeMenu = function TreeMenu(props) {
  var customizePrefixCls = props.prefixCls,
    className = props.className,
    treeDataSafe = props.treeData,
    treeNodeActionMenu = props.treeNodeActionMenu,
    _props$icon = props.icon,
    _icon = _props$icon === void 0 ? defaultIconRender : _props$icon,
    _props$switcherIconPo = props.switcherIconPosition,
    switcherIconPosition = _props$switcherIconPo === void 0 ? 'left' : _props$switcherIconPo,
    _props$indentUnitWidt = props.indentUnitWidth,
    indentUnitWidth = _props$indentUnitWidt === void 0 ? 24 : _props$indentUnitWidt,
    titleRender = props.titleRender,
    treeNodeActionMenuTrigger = props.treeNodeActionMenuTrigger,
    highlightKeyword = props.highlightKeyword,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    getPopupContainer = props.getPopupContainer,
    rest = _objectWithoutProperties(props, _excluded);
  var _usePrefixCls = usePrefixCls('tree-menu', customizePrefixCls),
    _usePrefixCls2 = _slicedToArray(_usePrefixCls, 2),
    treeMenuWrapPrefixCls = _usePrefixCls2[0],
    prefixCls = _usePrefixCls2[1];
  var classes = classNames(treeMenuWrapPrefixCls, className);
  var _useState = useState(treeDataSafe),
    _useState2 = _slicedToArray(_useState, 2),
    treeDataWithHighlight = _useState2[0],
    setTreeDataWithHighlight = _useState2[1];
  var getNode = useCallback(
    function (nodeData) {
      return /*#__PURE__*/ React.createElement(
        TreeNode,
        _objectSpread(
          _objectSpread(
            {
              itemKey: nodeData.key,
            },
            nodeData,
          ),
          {},
          {
            menu: treeNodeActionMenu,
            switcherIconPosition: switcherIconPosition,
            switcherIcon: rest.switcherIcon,
            fieldNames: props.fieldNames,
            titleRender: titleRender,
            treeNodeActionMenuTrigger: treeNodeActionMenuTrigger,
            highlightKeyword: highlightKeyword,
            getPopupContainer: getPopupContainer,
          },
        ),
      );
    },
    [
      treeNodeActionMenu,
      switcherIconPosition,
      rest.switcherIcon,
      props.fieldNames,
      titleRender,
      highlightKeyword,
      getPopupContainer,
    ],
  );
  useEffect(
    function () {
      if (!highlightKeyword) {
        setTreeDataWithHighlight(treeDataSafe);
        return;
      }
      setTreeDataWithHighlight(
        filterTreeDataByKeyword(treeDataSafe, highlightKeyword, props.fieldNames),
      );
    },
    [treeDataSafe, highlightKeyword, props.fieldNames],
  );
  return /*#__PURE__*/ React.createElement(
    TreeMenuWrap,
    {
      className: classes,
      prefixCls: prefixCls,
      switcherIconPosition: switcherIconPosition,
      indentUnitWidth: indentUnitWidth,
    },
    /*#__PURE__*/ React.createElement(
      Spin,
      {
        spinning: loading,
      },
      hasTreeData(treeDataWithHighlight)
        ? /*#__PURE__*/ React.createElement(
            DirectoryTree,
            _objectSpread(
              {
                treeData: treeDataWithHighlight,
                titleRender: getNode,
                blockNode: true,
                icon: function icon(props) {
                  return typeof _icon === 'function' ? _icon(props) : _icon;
                },
              },
              rest,
            ),
          )
        : /*#__PURE__*/ React.createElement(Empty, {
            image: Empty.PRESENTED_IMAGE_SIMPLE,
          }),
    ),
  );
};
var RefTreeMenu = TreeMenu;
RefTreeMenu.formatTreeDataFromArrayToTree = formatTreeDataFromArrayToTree;
export default RefTreeMenu;
function hasTreeData(treeData) {
  return Array.isArray(treeData) && treeData.length > 0;
}
